import React, { useEffect, useState } from "react";
import api from "../api";
import { useFilters } from "../dashboard/FilterContext";
import { RouteItemData } from "../types";
import { MultiSelect } from "./common/MultiSelect";

interface RouteFilter {
    id: string;
    label: string;
}

export const RouteFilter: React.FC = () => {

    const [routes, setRoutes] = useState<RouteFilter[]>();

    const { filters, setFilters } = useFilters();

    useEffect(() => {
        const fetchRoutes = async () => {
            try {
                const res = await api.get('/route/fetch-routes');
                const routeData = res.data.map((r: RouteItemData) => ({ id: r.id, label: r.name ?? r.id }));
                setRoutes(routeData);
            } catch (e) {
                console.error(e)
            }

        }
        fetchRoutes();
    }, []);

    return (
        <div className="ml-4">
            <MultiSelect
                options={routes ?? []}
                title="Routes"
                onSelect={(selectedIds: string[]) => {
                    console.log('id', selectedIds)
                    setFilters((prevFilters) => ({
                        ...prevFilters,
                        routeIds: selectedIds,
                    }));
                }} />
        </div>
    );
};